import { render, staticRenderFns } from "./relatedArticles.vue?vue&type=template&id=493b7a2d&scoped=true&lang=pug&"
import script from "./relatedArticles.vue?vue&type=script&lang=ts&"
export * from "./relatedArticles.vue?vue&type=script&lang=ts&"
import style0 from "./relatedArticles.vue?vue&type=style&index=0&id=493b7a2d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "493b7a2d",
  null
  
)

export default component.exports